export { DefaultAmplify as Amplify } from './initSingleton.mjs';
//# sourceMappingURL=index.mjs.map
